import { render, staticRenderFns } from "./TgsqEdit.vue?vue&type=template&id=6b223078&scoped=true"
import script from "./TgsqEdit.vue?vue&type=script&lang=js"
export * from "./TgsqEdit.vue?vue&type=script&lang=js"
import style0 from "./TgsqEdit.vue?vue&type=style&index=0&id=6b223078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b223078",
  null
  
)

export default component.exports